/**
 * App — raíz del árbol de rutas. Toda la config vive en `app/AppRoutes.tsx`
 * (generado desde `config/navConfig.ts`). Los providers están en `main.tsx`.
 */
import { useEffect } from 'react';
import AppRoutes from './app/AppRoutes';
import ErrorBoundary from './components/ErrorBoundary';

export default function App() {
  // Si la app lleva un rato estable, se rearma la recarga automática ante un chunk obsoleto.
  useEffect(() => {
    const t = window.setTimeout(() => {
      try { sessionStorage.removeItem('cn_chunk_reload'); } catch { /* ignorar */ }
    }, 15000);
    return () => window.clearTimeout(t);
  }, []);

  return (
    <ErrorBoundary variant="app">
      <AppRoutes />
    </ErrorBoundary>
  );
}
